export default __webpack_public_path__ + "static/media/greenTick.5e528318.svg";